import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./pages/Home";
import FourOFour from "./pages/FourOFour";

import logo from "./images/logo.svg";
import AppShell from "./AppShell";
import MembersMyCase from "./pages/members/MyCase";
import MembersOverview from "./pages/members/Overview";
import NewUsers from "./pages/users/NewUsers";
import AllUsers from "./pages/users/AllUsers";
import AllProjects from "./pages/projects/AllProjects";
import Project from "./pages/projects/Project";
import { AuthContext, AuthProvider } from "./context/AuthContext";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import { FetchProvider } from "./context/FetchContext";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

const UnauthenticatedRoutes = () => (
  <Switch>
    <Route path="/login">
      <Login />
    </Route>
    <Route path="/signup">
      <Signup />
    </Route>
    <Route path="/forgot-password">
      <ForgotPassword />
    </Route>
    <Route path="/reset-password/:token">
      <ResetPassword />
    </Route>
    <Route exact path="/">
      <Home />
    </Route>
    <Route path="*">
      <FourOFour />
    </Route>
  </Switch>
);

const AuthenticatedRoute = ({ children, ...rest }) => {
  const { authState } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={() =>
        authState.isAuthenticated ? (
          <AppShell>{children}</AppShell>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

const LoadingLogo = () => (
  <div className="self-center">
    <img className="w-32" src={logo} alt="logo" />
  </div>
);

const AppRoutes = () => {
  const { authState } = useContext(AuthContext);
  if (!authState.userInfo) {
    return (
      <div className="h-screen flex justify-center">
        <LoadingLogo />
      </div>
    );
  }
  return (
    <>
      <Switch>
        <AuthenticatedRoute path="/projects" exact>
          <AllProjects />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/projects/:id">
          <Project />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/members/overview">
          <MembersOverview />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/members/mine">
          <MembersMyCase />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/users" exact>
          <AllUsers />
        </AuthenticatedRoute>
        <AuthenticatedRoute path="/users/new">
          <NewUsers />
        </AuthenticatedRoute>
        <UnauthenticatedRoutes />
      </Switch>
    </>
  );
};

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <FetchProvider>
            <div className="bg-gray-100 flex flex-col h-screen">
              <AppRoutes />
            </div>
          </FetchProvider>
        </AuthProvider>
      </Router>
      <ToastContainer position="bottom-right" />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
